<template>
    <show-catalog v-bind:catalog="catalog"/>
</template>

<script>

import Vue from 'vue';
import EventBus from '../eventBus';

import axios from 'axios'
import showCatalog from './showCatalog.vue'
import setLanguage from '../mixins/setLanguage'
import setPostType from '../mixins/setPostType'
import setBlogId from '../mixins/setBlogId'

export default {
    data() {
        return {
            catalog: {
                headers: {
                    totalItems: Number,
                    currentPage: 1,
                    totalPages: Number,
                },
                items: [],
                loadingCatalog: true,
                postType: String
            },
            errors: [],
        }
    },
    mixins: [setLanguage, setPostType, setBlogId],
    components: {
        'show-catalog': showCatalog
    },
    created() {
        this.catalog.postType = this.setPostType();
        this.language = this.setLanguage();
        this.blogId = this.setBlogId();
        this.loadCatalogFromRESTApi();
    },
    mounted() {
        EventBus.$on('UPDATE_CATALOG', payLoad => {
            this.loadCatalogFromRESTApi(payLoad, true);
        });
    },
    methods: {
        loadCatalogFromRESTApi(payLoad, isUpdate = false) {
            let defUrl = window.location.origin + '/wp-json/wp/v2/' + this.catalog.postType + '?per_page=30&list_price=0,300000&orderby=list_price&order=asc&lang=nl&on_website_lappset=1';

            // Check if language has to be german by blogId (3 = Lappset website)
            if (this.blogId == 3) {
                defUrl = window.location.origin + '/wp-json/wp/v2/' + this.catalog.postType + '?per_page=30&list_price=0,300000&orderby=list_price&order=asc&lang=de';
            }

            // Projects
            if (this.catalog.postType == 'projecten') {
                defUrl = 'https://api.yalpinteractive.com/website/projects?language=' + this.language + '&per_page=30&page=1'
            }

            let pageNumber = 1;

            // Catch parameters on page load and create REST API URL
            if (isUpdate == false && window.location.hash) {
                let onLoadParameters = decodeURIComponent(window.location.hash.replace('#!/', '?'));

                defUrl = window.location.origin + '/wp-json/wp/v2/' + this.catalog.postType + onLoadParameters;
                // console.log(onLoadParameters);

                if (this.catalog.postType == 'projecten') {
                    defUrl = 'https://api.yalpinteractive.com/website/projects' + onLoadParameters;
                }
            }

            // Check for pre-settede filters in ACF
            let pageIdEl = document.getElementById('vue-page-id');
            let _this = this;
            if (isUpdate == false && pageIdEl && !window.location.hash) {
                let pageId = pageIdEl.getAttribute('data-page-id');
                if (pageId) {
                    let pageRestUrl = window.location.origin + '/wp-json/wp/v2/pages?include[]=' + pageId;
                    axios.get(pageRestUrl)
                            .then(response => {
                                if (Array.isArray(response.data)) {
                                    if (Array.isArray(response.data[0].acf.preset_filters)) {

                                        _this.presetFiltersFromPage = response.data[0].acf.preset_filters;
                                        let acfFilters = response.data[0].acf.preset_filters;
                                        this.createAxiosUrlFromPreSettedFilters(acfFilters);

                                        EventBus.$emit('UPDATE_FILTERS_FROM_ACF_AFTER_PAGE_LOAD', acfFilters);
                                    }
                                }
                            })
                            .catch(e => {
                                console.log(e);
                            })
                }
            }

            if (payLoad) {
                defUrl = payLoad.restUrl;
                pageNumber = payLoad.pageNumber;
            }

            if (isUpdate) {
                this.catalog.loadingCatalog = true;
            }

            // Execute if pageIdEl does not exist or when it does exist and url contains setted filters
            if (!pageIdEl || (pageIdEl && window.location.hash)) {
                console.log('first search', defUrl);
                this.loadCatalogAxios(defUrl, pageNumber);
            }

        },
        createAxiosUrlFromPreSettedFilters(filters) {
            // console.log('createAxiosUrlFromPreSettedFilters', filters);
            let defUrl = window.location.origin + '/wp-json/wp/v2/' + this.catalog.postType + '?per_page=30&list_price=0,300000&orderby=list_price&order=asc&lang=nl&on_website_lappset=1';

            // Check if language has to be german by blogId (3 = Lappset website)
            if (this.blogId == 3) {
                defUrl = window.location.origin + '/wp-json/wp/v2/' + this.catalog.postType + '?per_page=30&list_price=0,300000&orderby=list_price&order=asc&lang=de';
            }

            for (let row of filters) {
                // console.log(row);
                defUrl += '&' + row.filter_name + '=' + row.filter_value;
            }
            this.loadCatalogAxios(defUrl, 1);
        },
        loadCatalogAxios(url, pNumber) {
            axios.get(url)
                    .then(response => {
                        // Get 'headers' meta data
                        this.catalog.headers.totalItems = parseInt(response.headers['x-wp-total']);
                        this.catalog.headers.totalPages = parseInt(response.headers['x-wp-totalpages']);
                        this.catalog.headers.currentPage = pNumber;


                        if (this.catalog.postType == 'projecten') {
                            this.catalog.headers.totalItems = parseInt(response.data.meta.total_items);
                            this.catalog.headers.totalPages = parseInt(response.data.meta.total_pages);

                            this.catalog.items = response.data.data;
                        } else {
                            this.catalog.items = response.data;
                        }

                        this.catalog.loadingCatalog = false;

                    })
                    .catch(e => {
                        console.log(e);
                    })
        }
    },
}
</script>
